module.exports = __webpack_public_path__ + "img/taobaolianmeng.b6f04af9.png";